export const regexCPF = /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/;
export const regexDate = /(\d{2})[-.\/](\d{2})[-.\/](\d{4})/;
export const regexTelephone = /\d{4,5}\-\d{4}/g;
export const regexZipCode = /[0-9]{5}-[\d]{3}/g;

export const regexStringNotStartedInZero = /^[1-9]/;
